export const INITIALIZE_PAYMENT = "INITIALIZE_PAYMENT";
export const INITIALIZE_PAYMENT_SUCCESS = "INITIALIZE_PAYMENT_SUCCESS";
export const INITIALIZE_PAYMENT_ERROR = "INITIALIZE_PAYMENT_ERROR";

export const REGISTER_TRANSACTION = "REGISTER_TRANSACTION";
export const REGISTER_TRANSACTION_SUCCESS = "REGISTER_TRANSACTION_SUCCESS";
export const REGISTER_TRANSACTION_ERROR = "REGISTER_TRANSACTION_ERROR";

export const VERIFY_PAYSTACK = "VERIFY_PAYSTACK";
export const VERIFY_PAYSTACK_SUCCESS = "VERIFY_PAYSTACK_SUCCESS";
export const VERIFY_PAYSTACK_ERROR = "VERIFY_PAYSTACK_ERROR";

export const CLEAR_TRANS_REF = "CLEAR_TRANS_REF";